import Model from "./abstract/Model";

export default class VehicleSegment extends Model {

    constructor(props) {
        super();
        
        this.initializeAttributes(props);
    }
}
